import { patch } from '../../utils/http';

export const updateSlotPayrollFields = ({ accountId, employeeSlotId, values }) =>
  patch(`/accounts/${accountId}/employees-slots/${employeeSlotId}/payroll/fields`, { values });

export const updateSlotPayrollField = ({ accountId, employeeSlotId, payrollFieldId, valueKey = 'value', value }) =>
  patch(`/accounts/${accountId}/employees-slots/${employeeSlotId}/payroll/fields/${payrollFieldId}`, {
    [valueKey]: value
  });
